const africaOptions = window.africaOptions || {};

const africaState = window.africaState || {};

/**
 * Call and populated when the page is initialized. Used to prepare events for GTM.
 */
const toursData = window.toursData || [];

/**
 * Call and populated when the page is initialized. Used for block 'Misc sidebar content'.
 */
const discountsData = window.discountsData || [];

const trustPilotStars = window.trustPilotStars || {};

/**
 * We use this to store events and forward them to GTM
 */
const dataLayer = window.dataLayer || [];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const fbq = window.fbq || function(...args: any[]) {
    return;
};

// Back compatibility, need refactoring
const page = window.page = {
    type: africaOptions.page.action === 'view' || africaOptions.page.action === 'index' ?
        africaOptions.page.controller : africaOptions.page.action,
};

const tourData = window.tourData = {
    id: '',
    name: '',
    brand: '',
    brandLabel: '',
    category: '',
};

const destinationData = window.destinationData = {
    name: '',
    tourIds: [] as string[],
};
// End


export { africaOptions, trustPilotStars, africaState, toursData, discountsData, dataLayer, fbq, page, tourData, destinationData };
